<template>
  <div>
      <div v-if="toastStatus" id="toast" class="toast">
        <div class="alert_wrap">
            <div class="alert">
                <img src="./images/success_icon@3x.png">
                <h1>提交成功</h1>
                <span>果师兄服务团队会第一时间联系您</span>
                <a class="ok" @click="closeAlert()">好的</a>
            </div>
        </div>
        <div class="cover"></div>
    </div>
    
    <div class="content-wrapper">
        <div class="content-scroll">
            <div class="section first">
                <h2>果师兄为您提供：</h2>
                <ul>
                    <li class="m_top_3">快速的在线心理测试服务，如需服务请 <a href="https://wx.diggmind.com/?channel_id=35">点击此处</a> ！</li>
                    <li class="m_top_3">贴心的心理咨询服务，如需服务请留下您的信息！</li>
                    <li class="m_top_3">服务全程严格保护个人隐私，请放心填写咨询！</li>
                    <li class="m_top_3">免费心理咨询，添加咨询师微信：kxsheldon</li>
                </ul>
                <div class="line"></div>
            </div> 
            <div class="section second">
                <ul>
                    <li class="m_top_1 clearfix">
                        <div class="title fl"><i class="required"></i>联系方式：</div>
                        <div class="value fl"><input id="mobile" type="number" name="mobile" @blur="blurEvent" v-model="params.contact"></div>
                    </li>
                </ul>
                <div class="line"></div>
            </div>
            <div class="section third">
                <h2><i class="required"></i> 需要哪方面的心里咨询服务：</h2>
                <ul id="category" class="m_top_4 category">
                    <li>
                        <a class="btn" v-bind:class="{ active: index===categoryIndex1 }" v-for="(item,index) in categoryList1" :key="item" :title="item" @click="selectCategory($event,index,item,'line1')">{{item}}</a>
                    </li>
                    <li class="m_top_1">
                        <a class="btn" v-bind:class="{ active: index===categoryIndex2 }" v-for="(item,index) in categoryList2" :key="item" :title="item" @click="selectCategory($event,index,item,'line2')">{{item}}</a>
                    </li>
                </ul>
                <div class="feedback m_top_10">
                    <textarea id="feedback" name="feedback" maxlength="600" placeholder="我们愿意倾听您的任何想法（非必填）" @blur="blurEvent" v-model="content"></textarea>
                </div>
            </div> 
        </div>
    </div>
    <div class="footer">
        <a v-if="submitStatus" class="submit" @click="submit()">提交</a>
        <a v-if="!submitStatus" class="submit opacity">提交</a>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
export default {
    name:"diggme",
    metaInfo: {
          title: '填写信息' // set a title
    },
    data(){
        return{
            toastStatus:false,
            sexList:[
                {name:'男',value:'M'},
                {name:'女',value:'F'}
                ],
            sexIndex: -1,
            categoryList1:['婚姻咨询','情感咨询','亲子教育'],
            categoryList2:['情绪控制','倾诉聊天','个人发展'],
            categoryIndex1: -1,
            categoryIndex2: -1,
            params: {
                contact:'',
                functions:''
            },
            submitStatus: false,
            content: ''
        }
    },
    methods:{
        blurEvent() {
            window.scrollTo(0,0);
        },
        initParams() {
            this.params = {
                contact:'',
                functions:''
            }
            this.content = '';
            this.sexIndex = -1;
            this.categoryIndex1 = -1;
            this.categoryIndex2 = -1;
        },
        selectSex(e,index,value) {
            e.preventDefault();
            this.sexIndex = index;
            this.params.sex = value;
            this.validInput()
        },
        selectCategory (e,index,value,type) {
            e.preventDefault();
            this.params.functions = value;
            this.categoryIndex1 = -1;
            this.categoryIndex2 = -1;
            if(type==='line1'){
                this.categoryIndex1 = index;
            }else {
                this.categoryIndex2 = index;
            }
            this.validInput()
        },
        submit() {
            let obj = {
                sex:'',
                age:undefined,
                name:''
            }
            Object.assign(obj,this.params)
            obj['content'] = this.content;
            obj.age = parseInt(obj.age)
            this.$store.dispatch("submitDiggme",obj).then((res)=>{
                if(res.data.code===0){
                    this.toastStatus = true;
                    this.initParams()
                }else {
                    console.log(res)
                }             
            })
        },
        closeAlert() {
            this.toastStatus = false;
        },
        validInput(){
            this.submitStatus = true;
            for (const key in this.params) {
                if (this.params[key]==='' || this.params[key]===undefined) {
                    this.submitStatus = false
                }
            }
        }
    },
    created(){
        
    },
    mounted(){
    },
    watch: {
        params: {
          handler: function ( newVal, oldVal ) {
              this.validInput()
          },
          deep: true
        }
    },
    components:{
       
    }
}
</script>

<style lang="scss" scoped>
@import '../assets/css/base.scss';
.fl {
    float: left;
}
.clearfix::after {
    content: "\20";
    display: block;
    height: 0;
    clear: both;
}
i.required::before {
    content: '* ';
    color: red;
}
.clearfix {
    zoom: 1;
}

.m_top_1 {
    margin-top: pxtorem(10px);
}
.m_top_10 {
    margin-top: pxtorem(10px);
}
.m_top_3 {
    margin-top: pxtorem(8px);
}
.m_top_4 {
    margin-top: pxtorem(12px);
}

.m_right_1 {
    margin-right: pxtorem(14px);
}

.toast {
    position: fixed;
    width: 100%;
    height: 100%;
    z-index: 10;
}
.toast .alert_wrap {
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 4;
    display: flex;
    justify-content: center;
    margin-top: pxtorem(110px);
}
.toast .alert_wrap .alert {
    width: pxtorem(240px);
    height: pxtorem(258px);
    background-color: #ffffff;
    border-radius: pxtorem(8px);
    text-align: center;
}
.toast .alert_wrap .alert img {
    width: pxtorem(54px);
    height: pxtorem(54px);
    margin-top: pxtorem(36px);
}
.toast .alert_wrap .alert h1 {
    font-size:  pxtorem(24px);
    margin-top: pxtorem(10px);
}
.toast .alert_wrap .alert span {
    display: inline-block;
    margin-top: pxtorem(10px);
    color: #666666;
    font-size: pxtorem(12px);
}
.toast .alert_wrap .alert .ok {
    display: block;
    width: pxtorem(200px);
    height: pxtorem(38px);
    line-height: pxtorem(38px);
    background-color: #3189FF;
    border-radius: pxtorem(40px);
    color: #ffffff;
    margin: 0 auto;
    margin-top: pxtorem(24px);
    font-size: pxtorem(16px);
}

.toast .cover {
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: #000000;
    opacity: .5;
    z-index: 3;
}

.content-wrapper {
  width: 100%;
  position: fixed;
  top: 0;
  bottom: pxtorem(64px);
  overflow-y: auto;
  background-color: #ffffff;
}

.content-wrapper .content-scroll {
    margin: 0 pxtorem(6px);
}

.content-wrapper .first {
    padding: pxtorem(14px) pxtorem(14px) 0 pxtorem(14px);
}
.content-wrapper .first h2 {
    font-size: pxtorem(16px);
    font-weight: bold;
}
.content-wrapper .first li a {
    color:#3189FF;
    font-weight: 600;
}

.content-wrapper .third h2 {
    font-size: pxtorem(14px);
    font-weight: bold;
}
.content-wrapper .section li {
    font-size: pxtorem(14px);
}

.content-wrapper .line {
    border-bottom: 1px solid #E6E8ED;
    margin-top: pxtorem(12px);
}

.content-wrapper .btn {
    display: inline-block;
    width:pxtorem(90px);
    height: pxtorem(32px);
    border-radius: pxtorem(4px);
    text-align: center;
    background-color: #EDEDED;
    color: #4D4D4D;
    line-height: pxtorem(32px);
    font-size: pxtorem(12px);
}

.content-wrapper .btn.active {
    background-color: #3189FF;
    color: #ffffff;
    background-image: url('./images/select_icon@3x.png');
    background-repeat: no-repeat;
    background-size: 24% 80%;
    background-position: right top;
}


.content-wrapper .first li::before {
    content: "";
    width: 8px;
    height: 8px;
    background-color: #3189FF;
    border-radius: 100%;
    display: inline-block;
    margin-right: pxtorem(8px);
    -ms-flex-negative: 0;
    flex-shrink: 0;
}
.content-wrapper .second {
    padding:0 pxtorem(14px);
}
.content-wrapper .second li {
    line-height: pxtorem(32px);
}
.content-wrapper .second li .title {
    text-align: right;
    width:pxtorem(100px);
    font-weight: 600;
}

.content-wrapper .second li a {
    color: #4D4D4D;
}

.content-wrapper .second li .value {
    width:pxtorem(220px);
    padding-left: pxtorem(14px);
}


.content-wrapper .second li .value input {
    height:pxtorem(30px);
    border-radius: pxtorem(4px);
    border: 1px solid #E6E6E6;
    padding-left: pxtorem(10px);

    outline-color: invert ;
	outline-style: none ;
	outline-width: 0px ;
	text-shadow: none ;
	-webkit-appearance: none ;
	-webkit-user-select: text ;
	outline-color: transparent ;
	box-shadow: none;
}
.content-wrapper .second li .value [name="age"] {
    width: pxtorem(80px);
}
.content-wrapper .second li .value [name="name"], .content-wrapper .second li .value [name="mobile"] {
    width:pxtorem(186px);
}

.content-wrapper .third {
    padding: pxtorem(10px) pxtorem(20px) pxtorem(10px) pxtorem(20px);
}

.content-wrapper .third .category li {
    text-align: center;
    display: flex;
    justify-content: space-between;
}

.content-wrapper .third .feedback {
    margin-right: pxtorem(20px);
}
.content-wrapper .third textarea {
    border: none;
    background-color: #EDEDED;
    resize: none;
    border-radius: pxtorem(4px);
    outline: none;
    padding: pxtorem(10px);
    color: #999999;
    width: 100%;
    height: pxtorem(80px);
    font-size: pxtorem(12px);
}

.footer {
    width: 100%;
    height: pxtorem(68px);
    line-height: pxtorem(68px);
    text-align: center;
    border:1px solid #EDEDED;
    position: fixed;
    bottom: 0;
    background-color: #FAFAFA;
}

.footer .submit {
    display: inline-block;
    background-color: #3189FF;
    color: #ffffff;
    width: pxtorem(325px);
    height: pxtorem(42px);
    line-height: pxtorem(42px);
    border-radius: pxtorem(20px);
    font-size: pxtorem(16px);
}
.footer .submit.opacity {
    opacity: 0.6;
}


</style>



// WEBPACK FOOTER //
// src/static/Diggme.vue